import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import CreateNewUserForm from "components/ClinicalManagement/Common/CreateNewUserForm/CreateNewUserForm";

const AddNewPatient = () => {
  useEffect(() => {
    document.title = "Add New Patient";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <CreateNewUserForm moduleName="PATIENT" />
    </main>
  );
};

export default AddNewPatient;
